<div class="media-container">
  <!-- Filter Dropdown -->
  <div class="media-filter-section">
    <mat-form-field appearance="outline" class="media-filter-dropdown">
      <mat-label>Filter by Type</mat-label>
      <mat-select [(value)]="selectedMediaFilter" (selectionChange)="onMediaFilterChange($event.value)">
        <mat-option value="all">All</mat-option>
        <mat-option value="images">Images</mat-option>
        <mat-option value="files">Files (PDF, DOC, CSV)</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Media Table -->
  <div class="media-table-container" *ngIf="filteredMediaFiles.length > 0">
    <table class="media-table">
      <thead>
        <tr>
          <th>File</th>
          <th>Shared By</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let file of filteredMediaFiles; let i = index" class="media-row">
          <!-- File Column -->
          <td class="file-column">
            <!-- Image Preview -->
            <div class="file-info" *ngIf="file.type === 'IMAGE'" (click)="onPreviewImage(file, i)">
              <img [src]="file.previewUrl" class="file-thumbnail" alt="{{file.name}}" />
              <span class="file-name">{{ file.name }}</span>
            </div>

            <!-- File Icon -->
            <div class="file-info" *ngIf="file.type === 'FILE'" (click)="onDownloadFile(file)">
              <mat-icon class="file-icon" [ngClass]="getFileIconClass(file.mimeType)">
                {{ getFileIcon(file.mimeType) }}
              </mat-icon>
              <span class="file-name">{{ file.name }}</span>
            </div>
          </td>

          <!-- Shared By Column -->
          <td class="shared-by-column">
            <span class="shared-by-name">{{ file.completedBy?.name || 'N/A' }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- No Data Message -->
  <div *ngIf="filteredMediaFiles.length === 0" class="no-media-message">
    <mat-icon class="no-media-icon">folder_open</mat-icon>
    <p>No media files found</p>
  </div>
</div>
